$(document).ready(function() {
  
  showContactPopup();
  subMenuActive();
  playVideoOnClick();
  playBigVideoOnClick();
  if ($("#frontSlider").length > 0) {
    frontSlider($("#frontSlider"));
  }

  if ($("#logosSlider").length > 0) {
    logosSlider($("#logosSlider"));
  }

  if ($(".fade-slider").length > 0) {
    fadeSlider($(".fade-slider"));
  }

});


$(window).on('load', function(){
  $(".zip").twentytwenty();
});

var frontSlider = function(el) {
  el.slick({
    fade: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    dots: false,
    accessibility: false,
    arrows: false,
    draggable: false,
    cssEase: 'linear'
  });
};

var logosSlider = function(el) {
  el.slick({
    fade: false,
    slidesToShow: 7,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 1700,
    dots: false,
    accessibility: false,
    arrows: false,
    mobileFirst: true,
    draggable: false,
    responsive: [
      {
        breakpoint: 1499,
        settings: {
          slidesToShow: 7,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 6,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 319,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      }
    ]
  });
};

var fadeSlider = function(el) {
  el.slick({
    fade: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    dots: true,
    accessibility: false,
    arrows: false,
  });
};





function playVideoOnClick() {
  $('body').on('click', '.load-embed', function(e){
    $buttonId = $(this).attr('id');
    $embedData = $jsonCodesArray[$buttonId];
    $embedCode = $embedData['portfolio_embed_code'];
    $portfolio_name = $embedData['portfolio_name'];
    $portfolio_client = $embedData['portfolio_client'];
    $portfolio_desc = $embedData['portfolio_desc'];
    $portfolio_agency = $embedData['portfolio_agency'];
    $portfolio_realization = $embedData['portfolio_realization'];
    console.log($embedData);

    $title = $(".video-overlay__title");
    $title .text($portfolio_name);
  
    $text = $(".video-overlay__text");
    $text.text($portfolio_desc);
  
    $agency = $("#agency");
    $agency.html($portfolio_agency);
  
    $client = $("#client");
    $client.html($portfolio_client);

    $client = $("#realization");
    $client.html($portfolio_realization);

    $(".video-overlay__iframe").append('<iframe class="video-overlay__video" src="https://player.vimeo.com/video/'+$embedCode+'" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>')
    $('.video-pop').fadeIn(300);
  });
  $('.video-pop').on('click',function(e) {
    $('.video-pop').fadeOut(300);
    $('.video-overlay__video').remove();
  });
  $('.video-pop').find($('.video-overlay__video')).on('click', function(e){
    e.stopPropagation();
  });
}

function playBigVideoOnClick() {
  $('body').on('click', '.load-embed-main', function(e){
    $buttonId = $(this).attr('id');
    $embedData = $jsonCodesArray[$buttonId];
    $embedCode = $embedData['portfolio_embed_code'];
   
    $(".video-overlay__iframe").append('<iframe class="video-overlay__video" src="https://player.vimeo.com/video/'+$embedCode+'" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>')
    $('.video-pop-main').fadeIn(300);
  });
  $('.video-pop-main').on('click',function(e) {
    $('.video-pop-main').fadeOut(300);
    $('.video-overlay__video').remove();
  });
  $('.video-pop-main').find($('.video-overlay__video')).on('click', function(e){
    e.stopPropagation();
  });
}



function showContactPopup() {
  $('.show-contact-btn').on('click',function(e) {
   
    $('.contact-pop').fadeIn(300);
  });
  $('.contact-pop').on('click',function(e) {
      $('.contact-pop').fadeOut(300);
  });
  $('.contact-overlay__exit').on('click',function(e) {
    $('.contact-pop').fadeOut(300);
  });
  $('.contact-pop').find($('.contact-overlay__container')).on('click', function(e){
    e.stopPropagation();
  });
}

function subMenuActive() {
  $('.sub-menu__link').on('click',function(e) {
    $('.sub-menu__link').removeClass('sub-menu__link--active');
    $(this).addClass('sub-menu__link--active');
  });
}


$('a[href*="#"]')
  .not('[href="#"]')
  .not('[href="#0"]')
  .click(function(event) {
    if (
      location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') 
      && 
      location.hostname == this.hostname
    ) {
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
      if (target.length) {
        event.preventDefault();
        $('html, body').animate({
          scrollTop: target.offset().top
        }, 600, function() {
          var $target = $(target);
          $target.focus();
          if ($target.is(":focus")) { 
            return false;
          } else {
            $target.attr('tabindex','-1'); 
            $target.focus(); 
          };
        });
      }
    }
  });